let role = {
    name: '',
    cceHours: 0,
    cpdHours: 0
};

export default role;